import { ApolloClient } from 'apollo-client';
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { v4 as uuidV4 } from 'uuid';
import apolloLogger from 'apollo-link-logger';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';
import { getConfig } from './init';
import { ACTIVITY_STEP_UPLOAD_FAILED, stepStatusSelectors } from '@rosetta/gaia-progress';

export var GaiaApolloClient = void 0;

var addressSubmissionErrors = function addressSubmissionErrors() {
  var stepUploadInProgress = stepStatusSelectors.getStepUploadInProgress(GaiaApolloClient.reduxStore.getState());

  if (stepUploadInProgress) {
    GaiaApolloClient.reduxStore.dispatch({
      type: ACTIVITY_STEP_UPLOAD_FAILED
    });
  }
};

var errorLink = onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;

  var errorsStr = '';
  var params = {};
  if (graphQLErrors) {
    params.graphQLStacktrace = '';
    graphQLErrors.forEach(function (graphQLError) {
      if (errorsStr) {
        errorsStr += '\n';
      }
      errorsStr += '[GraphQL error]: Message: ' + graphQLError.message + ', Path: ' + graphQLError.path;
      if (graphQLError.extensions && graphQLError.extensions.exception && graphQLError.extensions.exception.stacktrace) {
        if (params.graphQLStacktrace) {
          params.graphQLStacktrace += '\n';
        }
        graphQLError.extensions.exception.stacktrace.forEach(function (traceLine) {
          params.graphQLStacktrace += traceLine;
        });
      }
    });
  }
  if (networkError) {
    if (errorsStr) {
      errorsStr += '\n';
    }
    errorsStr += '[Network error]: ' + networkError;
  }

  addressSubmissionErrors();

  GaiaApolloClient.reduxStore.dispatch({
    type: 'HANDLE_ERROR',
    payload: { message: errorsStr, params: params }
  });
});

export var createApolloClient = function createApolloClient(store) {
  var uri = getConfig().serverUrl + '/graphql';
  var uploadLink = createUploadLink({ uri: uri });
  var middlewareLink = setContext(function () {
    return {
      headers: {
        authorization: 'Bearer ' + sessionStorage.getItem('token'),
        'X-Request-ID': uuidV4()
      }
    };
  });

  var link = middlewareLink.concat(errorLink).concat(apolloLogger).concat(uploadLink);

  // course topics are not normalized in our content, and there are some which
  //  share an id, even though they contain different data.  The following code
  //  disambiguates topics which have different numbers of localizations, so they
  //  are not normalized in the apollo cache as if they were they same.
  var apolloCache = new InMemoryCache({
    dataIdFromObject: function dataIdFromObject(object) {
      if (object.__typename === 'Topic') {
        return object.id + object.localizations.length;
      } else {
        return defaultDataIdFromObject(object);
      }
    }
  });

  GaiaApolloClient = new ApolloClient({
    link: link,
    cache: apolloCache
  });
  GaiaApolloClient.reduxStore = store;
  return GaiaApolloClient;
};